// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-overlay {
  position: relative;
  --overlayArrowLeft: 21rem !important;
}

.profile-dropdown {
  max-width: 20.625rem;
  padding: 1.25rem;
}
.profile-dropdown ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.profile-dropdown ul li {
  cursor: pointer;
  padding: 5px 10px;
}
.profile-dropdown ul li:hover {
  background-color: #F2F7FC;
}`, "",{"version":3,"sources":["webpack://./src/components/ProfileDropdown/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,oCAAA;AACF;;AAEA;EACE,oBAAA;EACA,gBAAA;AACF;AACE;EACE,SAAA;EACA,UAAA;EACA,gBAAA;AACJ;AACI;EACE,eAAA;EACA,iBAAA;AACN;AAEI;EACE,yBAAA;AAAN","sourcesContent":[".dropdown-overlay {\n  position: relative;\n  --overlayArrowLeft: 21rem !important;\n}\n\n.profile-dropdown {\n  max-width: 20.625rem;\n  padding: 1.25rem;\n\n  ul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n\n    li {\n      cursor: pointer;\n      padding: 5px 10px;\n    }\n\n    li:hover {\n      background-color: #F2F7FC;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
